import { render, staticRenderFns } from "./DetalhesAditivoContrato.vue?vue&type=template&id=63711299"
import script from "./DetalhesAditivoContrato.vue?vue&type=script&lang=ts"
export * from "./DetalhesAditivoContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports